import {Component, OnInit, ViewChild} from '@angular/core';
import { MdDialogRef } from '@angular/material';
import {FormControl, Validators} from "@angular/forms";

@Component({
  selector: 'app-number-edit-dialog',
  templateUrl: './number-edit-dialog.component.html',
  styleUrls: ['./number-edit-dialog.component.scss']
})
export class NumberEditDialogComponent implements OnInit {

  constructor(public dialogRef: MdDialogRef<NumberEditDialogComponent>) { }

  public title = '';
  public numberToReturn = 0;
  public allowZero = true;
  public allowNegative = true;
  public inputPlaceholder = 'Número';

  private allowZeroError = false;
  private allowNegativeError = false;
  private maxNumberAllowedReachedError = false;

  private maxNumberAllowed = 1000000000;

  ngOnInit() {
    this.checkErrors();
  }

  checkErrors() {
    // si el numero es valido, verificamos que no se pase del maximo o minimo hardcodeado
    this.maxNumberAllowedReachedError = Math.abs(this.numberToReturn) >= this.maxNumberAllowed;

    if (!this.allowZero) {
      this.allowZeroError = this.numberToReturn === 0;
    }

    if (!this.allowNegative) {
      this.allowNegativeError = this.numberToReturn < 0;
    }

    return (this.allowNegativeError || this.allowZeroError || this.maxNumberAllowedReachedError);
  }

  onSubmit() {

    if (!this.checkErrors()) {
      this.dialogRef.close(this.numberToReturn);
    }

  }

  getInputHasErrors() {
    return (this.allowNegativeError || this.allowZeroError || this.maxNumberAllowedReachedError);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/number-edit-dialog/number-edit-dialog.component.ts